import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod } from "../core/base-api/methods-maker";
import { UsersPlaylistsApi } from "./users/playlists";
export var UsersApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(UsersApi, _BaseApi);

  var _super = _createSuper(UsersApi);

  function UsersApi(config) {
    var _this;

    _classCallCheck(this, UsersApi);

    _this = _super.call(this, config);
    _this.playlists = void 0;
    _this.playlists = new UsersPlaylistsApi(config);
    return _this;
  }

  return UsersApi;
}(BaseApi);
/**
 * profile summary for user
 */

UsersApi.prototype.show = makeMethod({
  method: 'get',
  path: Request.Users.Paths.Show,
  needAuth: true
});
/**
 * a user's likes
 */

UsersApi.prototype.listLikedVideos = makeMethod({
  method: 'get',
  path: Request.Users.Paths.ListLikedVideos,
  needAuth: true
});
/**
 * videos that a user has worked on
 */

UsersApi.prototype.listVideos = makeMethod({
  method: 'get',
  path: Request.Users.Paths.ListVideos,
  needAuth: true
});